import { SelectApplicationSubMenuDemoTableOutputData } from './select-application-sub-menu-demo-table-output-data.model';


export class SelectApplicationSubMenuDemoTableOutput implements ISelectApplicationSubMenuDemoTableOutput {
    status!: number;
    message!: string;
    data!: SelectApplicationSubMenuDemoTableOutputData;

    constructor(data?: ISelectApplicationSubMenuDemoTableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? SelectApplicationSubMenuDemoTableOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SelectApplicationSubMenuDemoTableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectApplicationSubMenuDemoTableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISelectApplicationSubMenuDemoTableOutput {
    status: number;
    message: string;
    data: SelectApplicationSubMenuDemoTableOutputData;
}

